import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';

export const Wrapper = styled('section')`
  position: fixed;
  top: 0%;
  transition: top 0.2s ease 0s;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.spaceGray};
  color: black;
`;

export const Header = styled(Row)`
  height: ${({ theme }) => theme.x8spacePx}px;
  position: absolute;
  top: ${({ theme }) => theme.safeAreaInsetTop};
  left: 0;
  width: 100vw;
  z-index: 1;
`;

export const BackButton = styled('button')`
  position: absolute;
  top: ${({ theme }) => theme.x2spacePx}px;
  right: ${({ theme }) => theme.x2spacePx}px;
  width: ${({ theme }) => theme.x5spacePx}px;
  height: ${({ theme }) => theme.x5spacePx}px;
  z-index: 1;
  svg {
    > * {
      fill: ${({ theme }) => theme.color.white};
    }
    top: ${({ theme }) => theme.x1spacePx}px;
    left: ${({ theme }) => theme.x1spacePx}px;
    width: ${({ theme }) => theme.x3spacePx}px;
    height: ${({ theme }) => theme.x3spacePx}px;
  }
`;

export const List = styled.ul`
  padding-left: ${({ theme }) => theme.x4spacePx}px;
  padding-right: ${({ theme }) => theme.x4spacePx}px;
  margin-bottom: ${({ theme }) => theme.x8spacePx}px;
`;

export const ListLabel = styled.li`
  ${({ theme }) => theme.typography.base}
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  padding: ${({ theme }) => theme.x1spacePx + 2}px 0;
  margin-top: ${({ theme }) => theme.x3spacePx}px;
  &:first-child {
    margin-top: 0;
  }
`;

export const ScrollPane = styled.div`
  overflow-y: auto;
  width: 100vw;
  height: 100vh;
  padding-top: ${({ theme }) => `calc(57px + ${theme.safeAreaInsetTop})`};

  position: absolute;
  top: 0;
  left: 0;
`;
